/** @jsx jsx */

import { css, jsx } from '@emotion/core';

import { VersionLifecycle } from 'app/developer-v3/types/statuses';

import type { SemVer } from 'app/developer-v3/types/version';

import Versions from './Versions';
import Status from './Status';

const Styles = {
  root: css`
    align-items: center;
    display: flex;
    gap: 10px;
    padding: 10px;
    width: 320px;
  `,
  versions: css`
    flex: 1;
    padding-left: 34px;
  `,
};

type Props = {
  onVersionChange: (version: SemVer) => {};
  version?: SemVer;
  versions: SemVer[];
  usersExceedLimit: boolean;
  versionLifecycle: VersionLifecycle;
};

function VersionPicker({
  onVersionChange,
  version,
  versions,
  usersExceedLimit,
  versionLifecycle,
}: Props) {
  return (
    <div css={Styles.root}>
      <div css={Styles.versions}>
        <Versions
          onChange={onVersionChange}
          version={version}
          versions={versions}
        />
      </div>
      <Status
        usersExceedLimit={usersExceedLimit}
        versionLifecycle={versionLifecycle}
      />
    </div>
  );
}

export default VersionPicker;
